import { request } from '@/plugins/http';

/**
 * 本地导入报文解析
 * @param params
 * @returns {AxiosPromise}
 */
const convertAscFile = params => request('/dbcflie/convertAscFile', params);

/**
 * 获取vin列表-加载历史报文
 * @param params
 * @returns {AxiosPromise}
 */
const getVinList = params => request('/dbcflie/getVinList', params);

/**
 * 查询加载历史报文
 * @param params
 * @returns {AxiosPromise}
 */
const convertAscFileFromDb = params => request('/dbcflie/convertAscFileFromDb', params);

/**
 * 加载DBC
 * @param params
 * @returns {AxiosPromise}
 */
const convertDbc = params => request('/dbcflie/convertDbc', params);

/**
 * 校验是否上传DBC文件
 * @param params
 * @returns {AxiosPromise}
 */
const checkDbc = params => request('/dbcflie/checkDbc', params);

export {
    convertAscFile, getVinList,convertAscFileFromDb,convertDbc,checkDbc
};
